import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [],total:0, error: "", message: "" }


export const getUserAction = createAsyncThunk(
    'get-user',
    async (data, { rejectWithValue }) => {
       
        try {
            const res = await axios.post(`/admins/api/users`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getUserSlice = createSlice({
    name: 'get-user',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getUserAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getUserAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData
            })
            builder.addCase(getUserAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData

            })
        },

})



export const getUserReducer = getUserSlice.reducer